import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending",
  "use": "icon-pending-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-pending\"><g><g><ellipse cx=\"7\" cy=\"7\" rx=\"7\" ry=\"7\" fill=\"#FFFFFF\" fill-opacity=\"1\" /><ellipse cx=\"7\" cy=\"7\" rx=\"6.5\" ry=\"6.5\" fill-opacity=\"0\" stroke-opacity=\"1\" stroke=\"#E5E5E5\" fill=\"none\" stroke-width=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol